import {
  createSelector,
  createStructuredSelector,
  OutputSelector,
} from 'reselect'
// @ts-ignore
import { getFormValues } from 'redux-form'
import { capitalizeFirstLetter } from 'Helpers/layoutHelpers'

import {
  Coupon,
  Shopper,
  BudgetRange,
  TiktokCampaign,
  SpotifyCampaign,
  Genre,
  Language,
} from 'Types/index'

import { createDeepEqualSelector } from './index'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getState = (state: any) => state.schedule

export const getScheduledSpotifyCampaign: OutputSelector<
  [],
  SpotifyCampaign,
  (res: unknown) => unknown
> = createDeepEqualSelector(
  getState,
  ({ scheduledCampaign }) => scheduledCampaign
)

export const getIsUpdateCampaignLoading: OutputSelector<
  [],
  boolean,
  (res: unknown) => unknown
> = createDeepEqualSelector(
  getState,
  ({ isUpdateCampaignLoading }) => isUpdateCampaignLoading
)

export const getScheduledTiktokCampaign: OutputSelector<
  [],
  TiktokCampaign,
  (res: unknown) => unknown
> = createDeepEqualSelector(
  getState,
  ({ scheduledCampaign }) => scheduledCampaign
)

export const getScheduledCampaign = createSelector(
  getState,
  ({ scheduledCampaign }) => scheduledCampaign
)
export const getCurators = createSelector(getState, ({ curators }) => curators)
export const getCountry = createSelector(getState, ({ country }) => country)
export const getCuratorsListIsEmpty = createSelector(
  getState,
  ({ curatorsListIsEmpty }) => curatorsListIsEmpty
)

export const getScheduledSpotifyCampaignGenres: OutputSelector<
  [],
  Array<Genre>,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ scheduledCampaign }) =>
  // @ts-ignore
  scheduledCampaign?.genres?.map(genre => ({
    value: genre.id,
    label: capitalizeFirstLetter(genre.name),
  }))
)

export const getScheduledSpotifyCampaignLanguages: OutputSelector<
  [],
  Array<Language>,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ scheduledCampaign }) =>
  // @ts-ignore
  scheduledCampaign?.languages?.map(language => ({
    value: language.id,
    label: capitalizeFirstLetter(language.name),
  }))
)

export const getShopperToken3DS: OutputSelector<
  unknown,
  Coupon,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ shopperToken3DS }) => shopperToken3DS)

export const getCoupon: OutputSelector<
  unknown,
  Coupon,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ coupon }) => coupon)

export const getPftoken: OutputSelector<
  unknown,
  string,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ pfToken }) => pfToken)

export const getShopper: OutputSelector<
  unknown,
  Shopper,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ shopper }) => shopper)

export const getScheduleFullData = createStructuredSelector({
  getScheduledCampaign,
  getCurators,
})

export const getBudgetRange: OutputSelector<
  unknown,
  BudgetRange,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ budgetRange }) => budgetRange)

export const formStates = createStructuredSelector({
  startDateForm: state => getFormValues('campaign_start_date')(state),
  couponForm: state => getFormValues('coupon_form')(state),
})
